import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import * as React from 'react';
import { uid } from 'react-uid';
import type { ValueComponentProps } from '../../../design-system';
import type { ConnectorFormFields } from './ConnectorSection';

const getDescription = ({ connectorType, connectorFormat, maxAmperage, maxVoltage, powerType }: ConnectorFormFields) =>
  [connectorType, connectorFormat, powerType, `${maxVoltage}V`, `${maxAmperage}A`].join(', ');

type ConnectorsValueProps = ValueComponentProps<ConnectorFormFields[]>;

export const ConnectorsValue: React.FC<ConnectorsValueProps> = ({ value }: ConnectorsValueProps) => {
  if (value.length === 0) {
    return <>No connectors</>;
  }

  return (
    <List disablePadding dense>
      {value.map((connector, idx) => (
        <ListItem key={uid(connector, idx)} disableGutters>
          <ListItemText primary={`Connector ${idx + 1}`} secondary={getDescription(connector)} />
        </ListItem>
      ))}
    </List>
  );
};
